const AUTH_COMPANY_ID = 'authCompanyId'
const SUBDOMAIN = 'subdomain'
const REGISTER_DATA = 'registerData'

export { AUTH_COMPANY_ID, SUBDOMAIN, REGISTER_DATA }
